// extracted by mini-css-extract-plugin
export default {"confettiContainer":"Confetti_confettiContainer__b3F55","confettiPiece":"Confetti_confettiPiece__kP-YM","confettiFall":"Confetti_confettiFall__pZc0s"};